import {
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  coerceAtMost322komnqp70ag as coerceAtMost,
} from '../ranges/_Ranges.mjs';
import { takeHighestOneBit9p7rdtda63bc as takeHighestOneBit } from '../NumbersJs.mjs';
import {
  ConcurrentModificationException3974vl9oonkcj as ConcurrentModificationException,
  RuntimeException1r3t0zl97011n as RuntimeException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../exceptions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../Unit.mjs';
import { Companion_instance1el8xrhi64v9a as Companion_instance } from './AbstractList.mjs';
import {
  copyOfUninitializedElements3uqjltwtgc0ej as copyOfUninitializedElements,
  arrayOfUninitializedElementsg6b068zrcm8j as arrayOfUninitializedElements,
  resetRangeiqi6axdujnmn as resetRange,
  resetAt1d0jjdeh7nn7m as resetAt,
} from './ArrayFunctions.mjs';
import { copyOf3rutauicler23 as copyOf } from './_ArraysJs.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
  protoOf180f3jzyo7rfj as protoOf,
} from '../js/coreRuntime.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../hacks.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx } from '../Char.mjs';
import {
  Entry2xmjmyutzoq3p as Entry,
  MutableEntry12w2i19w0igk5 as MutableEntry,
  KtMap140uvy3s5zad8 as KtMap,
} from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../Library.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../text/StringBuilderJs.mjs';
import {
  containsAllEntries1q58uduc9e3y6 as containsAllEntries,
  InternalMap26d9hvxb47nvz as InternalMap,
} from './InternalMap.mjs';
//region block: imports
var imul = Math.imul;
var clz32 = Math.clz32;
//endregion
//region block: pre-declaration
//endregion
function computeHashSize($this, capacity) {
  return takeHighestOneBit(imul(coerceAtLeast(capacity, 1), 3));
}
function computeShift($this, hashSize) {
  // Inline function 'kotlin.countLeadingZeroBits' call
  return clz32(hashSize) + 1 | 0;
}
function checkForComodification($this) {
  if (!($this.oa_1.z8_1 === $this.qa_1))
    throw ConcurrentModificationException().na('The backing map has been modified after this entry was obtained.');
}
function _get_capacity__a9k9f3($this) {
  return $this.s8_1.length;
}
function _get_hashSize__tftcho($this) {
  return $this.v8_1.length;
}
function registerModification($this) {
  $this.z8_1 = $this.z8_1 + 1 | 0;
}
function ensureExtraCapacity($this, n) {
  if (shouldCompact($this, n)) {
    compact($this, true);
  } else {
    ensureCapacity($this, $this.x8_1 + n | 0);
  }
}
function shouldCompact($this, extraCapacity) {
  var spareCapacity = _get_capacity__a9k9f3($this) - $this.x8_1 | 0;
  var gaps = $this.x8_1 - $this.q2() | 0;
  return spareCapacity < extraCapacity && (gaps + spareCapacity | 0) >= extraCapacity && gaps >= (_get_capacity__a9k9f3($this) / 4 | 0);
}
function ensureCapacity($this, minCapacity) {
  if (minCapacity < 0)
    throw RuntimeException().ra('too many elements');
  if (minCapacity > _get_capacity__a9k9f3($this)) {
    var newSize = Companion_instance.sa(_get_capacity__a9k9f3($this), minCapacity);
    $this.s8_1 = copyOfUninitializedElements($this.s8_1, newSize);
    var tmp = $this;
    var tmp0_safe_receiver = $this.t8_1;
    tmp.t8_1 = tmp0_safe_receiver == null ? null : copyOfUninitializedElements(tmp0_safe_receiver, newSize);
    $this.u8_1 = copyOf($this.u8_1, newSize);
    var newHashSize = computeHashSize(Companion_instance_0, newSize);
    if (newHashSize > _get_hashSize__tftcho($this)) {
      rehash($this, newHashSize);
    }
  }
}
function allocateValuesArray($this) {
  var curValuesArray = $this.t8_1;
  if (!(curValuesArray == null))
    return curValuesArray;
  var newValuesArray = arrayOfUninitializedElements(_get_capacity__a9k9f3($this));
  $this.t8_1 = newValuesArray;
  return newValuesArray;
}
function hash($this, key) {
  return key == null ? 0 : imul(hashCode(key), -1640531527) >>> $this.y8_1 | 0;
}
function compact($this, updateHashArray) {
  var i = 0;
  var j = 0;
  var valuesArray = $this.t8_1;
  while (i < $this.x8_1) {
    var hash = $this.u8_1[i];
    if (hash >= 0) {
      $this.s8_1[j] = $this.s8_1[i];
      if (!(valuesArray == null)) {
        valuesArray[j] = valuesArray[i];
      }
      if (updateHashArray) {
        $this.u8_1[j] = hash;
        $this.v8_1[hash] = j + 1 | 0;
      }
      j = j + 1 | 0;
    }
    i = i + 1 | 0;
  }
  resetRange($this.s8_1, j, $this.x8_1);
  if (valuesArray == null)
    null;
  else {
    resetRange(valuesArray, j, $this.x8_1);
  }
  $this.x8_1 = j;
}
function rehash($this, newHashSize) {
  registerModification($this);
  if ($this.x8_1 > $this.a9_1) {
    compact($this, false);
  }
  $this.v8_1 = new Int32Array(newHashSize);
  $this.y8_1 = computeShift(Companion_instance_0, newHashSize);
  var i = 0;
  while (i < $this.x8_1) {
    var _unary__edvuaz = i;
    i = _unary__edvuaz + 1 | 0;
    if (!putRehash($this, _unary__edvuaz)) {
      throw IllegalStateException().o('This cannot happen with fixed magic multiplier and grow-only hash array. Have object hashCodes changed?');
    }
  }
}
function putRehash($this, i) {
  var hash_0 = hash($this, $this.s8_1[i]);
  var probesLeft = $this.w8_1;
  while (true) {
    var index = $this.v8_1[hash_0];
    if (index === 0) {
      $this.v8_1[hash_0] = i + 1 | 0;
      $this.u8_1[i] = hash_0;
      return true;
    }
    probesLeft = probesLeft - 1 | 0;
    if (probesLeft < 0)
      return false;
    var _unary__edvuaz = hash_0;
    hash_0 = _unary__edvuaz - 1 | 0;
    if (_unary__edvuaz === 0)
      hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
  }
}
function findKey($this, key) {
  var hash_0 = hash($this, key);
  var probesLeft = $this.w8_1;
  while (true) {
    var index = $this.v8_1[hash_0];
    if (index === 0)
      return -1;
    if (equals($this.s8_1[index - 1 | 0], key))
      return index - 1 | 0;
    probesLeft = probesLeft - 1 | 0;
    if (probesLeft < 0)
      return -1;
    var _unary__edvuaz = hash_0;
    hash_0 = _unary__edvuaz - 1 | 0;
    if (_unary__edvuaz === 0)
      hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
  }
}
function findValue($this, value) {
  var i = $this.x8_1;
  $l$loop: while (true) {
    i = i - 1 | 0;
    if (!(i >= 0)) {
      break $l$loop;
    }
    if ($this.u8_1[i] >= 0 && equals(ensureNotNull($this.t8_1)[i], value))
      return i;
  }
  return -1;
}
function addKey($this, key) {
  $this.q9();
  retry: while (true) {
    var hash_0 = hash($this, key);
    var tentativeMaxProbeDistance = coerceAtMost(imul($this.w8_1, 2), _get_hashSize__tftcho($this) / 2 | 0);
    var probeDistance = 0;
    while (true) {
      var index = $this.v8_1[hash_0];
      if (index === 0) {
        if ($this.x8_1 >= _get_capacity__a9k9f3($this)) {
          ensureExtraCapacity($this, 1);
          continue retry;
        }
        var _unary__edvuaz = $this.x8_1;
        $this.x8_1 = _unary__edvuaz + 1 | 0;
        var putIndex = _unary__edvuaz;
        $this.s8_1[putIndex] = key;
        $this.u8_1[putIndex] = hash_0;
        $this.v8_1[hash_0] = putIndex + 1 | 0;
        $this.a9_1 = $this.a9_1 + 1 | 0;
        registerModification($this);
        if (probeDistance > $this.w8_1)
          $this.w8_1 = probeDistance;
        return putIndex;
      }
      if (equals($this.s8_1[index - 1 | 0], key)) {
        return -index | 0;
      }
      probeDistance = probeDistance + 1 | 0;
      if (probeDistance > tentativeMaxProbeDistance) {
        rehash($this, imul(_get_hashSize__tftcho($this), 2));
        continue retry;
      }
      var _unary__edvuaz_0 = hash_0;
      hash_0 = _unary__edvuaz_0 - 1 | 0;
      if (_unary__edvuaz_0 === 0)
        hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
    }
  }
}
function removeEntryAt($this, index) {
  resetAt($this.s8_1, index);
  var tmp0_safe_receiver = $this.t8_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    resetAt(tmp0_safe_receiver, index);
  }
  removeHashAt($this, $this.u8_1[index]);
  $this.u8_1[index] = -1;
  $this.a9_1 = $this.a9_1 - 1 | 0;
  registerModification($this);
}
function removeHashAt($this, removedHash) {
  var hash_0 = removedHash;
  var hole = removedHash;
  var probeDistance = 0;
  while (true) {
    var _unary__edvuaz = hash_0;
    hash_0 = _unary__edvuaz - 1 | 0;
    if (_unary__edvuaz === 0)
      hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
    var index = $this.v8_1[hash_0];
    probeDistance = probeDistance + 1 | 0;
    if (probeDistance > $this.w8_1) {
      $this.v8_1[hole] = 0;
      return Unit_instance;
    }
    if (index === 0) {
      $this.v8_1[hole] = 0;
      return Unit_instance;
    }
    var otherHash = hash($this, $this.s8_1[index - 1 | 0]);
    if (((otherHash - hash_0 | 0) & (_get_hashSize__tftcho($this) - 1 | 0)) >= probeDistance) {
      $this.v8_1[hole] = index;
      $this.u8_1[index - 1 | 0] = hole;
      hole = hash_0;
      probeDistance = 0;
    }
  }
}
function contentEquals($this, other) {
  return $this.a9_1 === other.q2() && $this.ba(other.l3());
}
function putEntry($this, entry) {
  var index = addKey($this, entry.m3());
  var valuesArray = allocateValuesArray($this);
  if (index >= 0) {
    valuesArray[index] = entry.n3();
    return true;
  }
  var oldValue = valuesArray[(-index | 0) - 1 | 0];
  if (!equals(entry.n3(), oldValue)) {
    valuesArray[(-index | 0) - 1 | 0] = entry.n3();
    return true;
  }
  return false;
}
function putAllEntries($this, from) {
  if (from.n1())
    return false;
  ensureExtraCapacity($this, from.q2());
  var it = from.p1();
  var updated = false;
  while (it.q1()) {
    if (putEntry($this, it.r1()))
      updated = true;
  }
  return updated;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.ta_1 = -1640531527;
        this.ua_1 = 8;
        this.va_1 = 2;
        this.wa_1 = -1;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  return Companion_instance_0;
}
var ItrClass;
function Itr() {
  if (ItrClass === VOID) {
    class $ {
      constructor(map) {
        this.xa_1 = map;
        this.ya_1 = 0;
        this.za_1 = -1;
        this.ab_1 = this.xa_1.z8_1;
        this.bb();
      }
      bb() {
        while (this.ya_1 < this.xa_1.x8_1 && this.xa_1.u8_1[this.ya_1] < 0) {
          this.ya_1 = this.ya_1 + 1 | 0;
        }
      }
      q1() {
        return this.ya_1 < this.xa_1.x8_1;
      }
      p6() {
        this.cb();
        // Inline function 'kotlin.check' call
        if (!!(this.za_1 === -1)) {
          var message = 'Call next() before removing element from the iterator.';
          throw IllegalStateException().o(toString(message));
        }
        this.xa_1.q9();
        removeEntryAt(this.xa_1, this.za_1);
        this.za_1 = -1;
        this.ab_1 = this.xa_1.z8_1;
      }
      cb() {
        if (!(this.xa_1.z8_1 === this.ab_1))
          throw ConcurrentModificationException().db();
      }
    }
    initMetadataForClass($, 'Itr');
    ItrClass = $;
  }
  return ItrClass;
}
var KeysItrClass;
function KeysItr() {
  if (KeysItrClass === VOID) {
    class $ extends Itr() {
      r1() {
        this.cb();
        if (this.ya_1 >= this.xa_1.x8_1)
          throw NoSuchElementException().t6();
        var tmp = this;
        var _unary__edvuaz = this.ya_1;
        this.ya_1 = _unary__edvuaz + 1 | 0;
        tmp.za_1 = _unary__edvuaz;
        var result = this.xa_1.s8_1[this.za_1];
        this.bb();
        return result;
      }
    }
    initMetadataForClass($, 'KeysItr');
    KeysItrClass = $;
  }
  return KeysItrClass;
}
var ValuesItrClass;
function ValuesItr() {
  if (ValuesItrClass === VOID) {
    class $ extends Itr() {
      r1() {
        this.cb();
        if (this.ya_1 >= this.xa_1.x8_1)
          throw NoSuchElementException().t6();
        var tmp = this;
        var _unary__edvuaz = this.ya_1;
        this.ya_1 = _unary__edvuaz + 1 | 0;
        tmp.za_1 = _unary__edvuaz;
        var result = ensureNotNull(this.xa_1.t8_1)[this.za_1];
        this.bb();
        return result;
      }
    }
    initMetadataForClass($, 'ValuesItr');
    ValuesItrClass = $;
  }
  return ValuesItrClass;
}
var EntriesItrClass;
function EntriesItr() {
  if (EntriesItrClass === VOID) {
    class $ extends Itr() {
      r1() {
        this.cb();
        if (this.ya_1 >= this.xa_1.x8_1)
          throw NoSuchElementException().t6();
        var tmp = this;
        var _unary__edvuaz = this.ya_1;
        this.ya_1 = _unary__edvuaz + 1 | 0;
        tmp.za_1 = _unary__edvuaz;
        var result = new (EntryRef())(this.xa_1, this.za_1);
        this.bb();
        return result;
      }
      qb() {
        if (this.ya_1 >= this.xa_1.x8_1)
          throw NoSuchElementException().t6();
        var tmp = this;
        var _unary__edvuaz = this.ya_1;
        this.ya_1 = _unary__edvuaz + 1 | 0;
        tmp.za_1 = _unary__edvuaz;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.xa_1.s8_1[this.za_1];
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        var tmp_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_0 = ensureNotNull(this.xa_1.t8_1)[this.za_1];
        var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
        var result = tmp_0 ^ (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
        this.bb();
        return result;
      }
      rb(sb) {
        if (this.ya_1 >= this.xa_1.x8_1)
          throw NoSuchElementException().t6();
        var tmp = this;
        var _unary__edvuaz = this.ya_1;
        this.ya_1 = _unary__edvuaz + 1 | 0;
        tmp.za_1 = _unary__edvuaz;
        var key = this.xa_1.s8_1[this.za_1];
        if (equals(key, this.xa_1))
          sb.m1('(this Map)');
        else
          sb.s1(key);
        sb.o1(_Char___init__impl__6a9atx(61));
        var value = ensureNotNull(this.xa_1.t8_1)[this.za_1];
        if (equals(value, this.xa_1))
          sb.m1('(this Map)');
        else
          sb.s1(value);
        this.bb();
      }
    }
    initMetadataForClass($, 'EntriesItr');
    EntriesItrClass = $;
  }
  return EntriesItrClass;
}
var EntryRefClass;
function EntryRef() {
  if (EntryRefClass === VOID) {
    class $ {
      constructor(map, index) {
        this.oa_1 = map;
        this.pa_1 = index;
        this.qa_1 = this.oa_1.z8_1;
      }
      m3() {
        checkForComodification(this);
        return this.oa_1.s8_1[this.pa_1];
      }
      n3() {
        checkForComodification(this);
        return ensureNotNull(this.oa_1.t8_1)[this.pa_1];
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (!(other == null) ? isInterface(other, Entry()) : false) {
          tmp_0 = equals(other.m3(), this.m3());
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals(other.n3(), this.n3());
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.m3();
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        var tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_0 = this.n3();
        var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
        return tmp ^ (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
      }
      toString() {
        return toString_0(this.m3()) + '=' + toString_0(this.n3());
      }
    }
    initMetadataForClass($, 'EntryRef', VOID, VOID, [MutableEntry()]);
    EntryRefClass = $;
  }
  return EntryRefClass;
}
var InternalHashMapClass;
function InternalHashMap() {
  if (InternalHashMapClass === VOID) {
    class $ {
      constructor(keysArray, valuesArray, presenceArray, hashArray, maxProbeDistance, length) {
        return new.target.sb(keysArray, valuesArray, presenceArray, hashArray, maxProbeDistance, length);
      }
      static sb(keysArray, valuesArray, presenceArray, hashArray, maxProbeDistance, length) {
        var $this = createThis(this);
        $this.s8_1 = keysArray;
        $this.t8_1 = valuesArray;
        $this.u8_1 = presenceArray;
        $this.v8_1 = hashArray;
        $this.w8_1 = maxProbeDistance;
        $this.x8_1 = length;
        $this.y8_1 = computeShift(Companion_instance_0, _get_hashSize__tftcho($this));
        $this.z8_1 = 0;
        $this.a9_1 = 0;
        $this.b9_1 = false;
        return $this;
      }
      q2() {
        return this.a9_1;
      }
      static c9() {
        return this.ia(8);
      }
      static ia(initialCapacity) {
        return this.sb(arrayOfUninitializedElements(initialCapacity), null, new Int32Array(initialCapacity), new Int32Array(computeHashSize(Companion_instance_0, initialCapacity)), 2, 0);
      }
      static h9(original) {
        var $this = this.ia(original.q2());
        $this.c5(original);
        return $this;
      }
      static e9(initialCapacity, loadFactor) {
        var $this = this.ia(initialCapacity);
        // Inline function 'kotlin.require' call
        if (!(loadFactor > 0)) {
          var message = 'Non-positive load factor: ' + loadFactor;
          throw IllegalArgumentException().o2(toString(message));
        }
        return $this;
      }
      tb() {
        this.q9();
        this.b9_1 = true;
      }
      w4(value) {
        return findValue(this, value) >= 0;
      }
      x4(key) {
        var index = findKey(this, key);
        if (index < 0)
          return null;
        return ensureNotNull(this.t8_1)[index];
      }
      i9(key) {
        return findKey(this, key) >= 0;
      }
      a5(key, value) {
        var index = addKey(this, key);
        var valuesArray = allocateValuesArray(this);
        if (index < 0) {
          var oldValue = valuesArray[(-index | 0) - 1 | 0];
          valuesArray[(-index | 0) - 1 | 0] = value;
          return oldValue;
        } else {
          valuesArray[index] = value;
          return null;
        }
      }
      c5(from) {
        this.q9();
        putAllEntries(this, from.l3());
      }
      b5(key) {
        this.q9();
        var index = findKey(this, key);
        if (index < 0)
          return null;
        var oldValue = ensureNotNull(this.t8_1)[index];
        removeEntryAt(this, index);
        return oldValue;
      }
      s4() {
        this.q9();
        var inductionVariable = 0;
        var last = this.x8_1 - 1 | 0;
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var hash = this.u8_1[i];
            if (hash >= 0) {
              this.v8_1[hash] = 0;
              this.u8_1[i] = -1;
            }
          }
           while (!(i === last));
        resetRange(this.s8_1, 0, this.x8_1);
        var tmp0_safe_receiver = this.t8_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          resetRange(tmp0_safe_receiver, 0, this.x8_1);
        }
        this.a9_1 = 0;
        this.x8_1 = 0;
        registerModification(this);
      }
      equals(other) {
        var tmp;
        if (other === this) {
          tmp = true;
        } else {
          var tmp_0;
          if (!(other == null) ? isInterface(other, KtMap()) : false) {
            tmp_0 = contentEquals(this, other);
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      hashCode() {
        var result = 0;
        var it = this.x9();
        while (it.q1()) {
          result = result + it.qb() | 0;
        }
        return result;
      }
      toString() {
        var sb = StringBuilder().ub(2 + imul(this.a9_1, 3) | 0);
        sb.m1('{');
        var i = 0;
        var it = this.x9();
        while (it.q1()) {
          if (i > 0) {
            sb.m1(', ');
          }
          it.rb(sb);
          i = i + 1 | 0;
        }
        sb.m1('}');
        return sb.toString();
      }
      q9() {
        if (this.b9_1)
          throw UnsupportedOperationException().j8();
      }
      aa(entry) {
        var index = findKey(this, entry.m3());
        if (index < 0)
          return false;
        return equals(ensureNotNull(this.t8_1)[index], entry.n3());
      }
      vb(entry) {
        return this.aa(isInterface(entry, Entry()) ? entry : THROW_CCE());
      }
      p9() {
        return new (KeysItr())(this);
      }
      u9() {
        return new (ValuesItr())(this);
      }
      x9() {
        return new (EntriesItr())(this);
      }
    }
    protoOf($).ba = containsAllEntries;
    initMetadataForClass($, 'InternalHashMap', $.c9, VOID, [InternalMap()]);
    InternalHashMapClass = $;
  }
  return InternalHashMapClass;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  InternalHashMap as InternalHashMapmpvpylj0ut6l,
};
//endregion

//# sourceMappingURL=InternalHashMap.mjs.map
